import { render, staticRenderFns } from "./UmDbDeck.vue?vue&type=template&id=398604ea&"
import script from "./UmDbDeck.vue?vue&type=script&lang=js&"
export * from "./UmDbDeck.vue?vue&type=script&lang=js&"
import style0 from "./UmDbDeck.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports